<template>
    <div class="row">
        <div class="col-12">
            <p>
                <b>{{ $t('partido.activacion_abono') }}</b>
            </p>
            <ul>
                <li>{{ $t('partido.una_entrada', {abono: teatro.texto_abono}) }}</li>
                <li>{{ $t('partido.validez_abono', {abonado: teatro.texto_abonado}) }}</li>
                <li>{{ $t('partido.acceso_nominativo', {abono: teatro.texto_abono}) }}</li>
                <li>{{ $t('partido.abono_personal', {abono: teatro.texto_abono}) }}</li>
                <li>{{ $t('partido.tiempo_suficiente') }}</li>
            </ul>
            <p>{{ $t('partido.cuestion', { email: manager.email_incidencias ? manager.email_incidencias : 'info@compralaentrada.com' }) }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        }
    }
</script>